import UserApi from "../../../api/UserApi";
import UserPersistence from "../../../persistence/UserPersistence";
import { router } from "../../../router/index";
import { MSG_MODES, MSG_TYPES, setMessage } from "../../../libs/message";
import { menuRouters, ROUTER_DEFAULT } from "../../../router/router";
import { getMenuListByAccessCode, transformData } from "./helper";
import _ from "../../../libs/utils/ObjectUtils";
import OrgApi from "../../../api/OrgApi";
import AppPersistence from "../../../persistence/AppPersistence";
import ArrayUtils from "../../../libs/utils/ArrayUtils";
import { setRouterTitle } from "../../../libs/combineAuthRouters";
import api from './../../../api/account-info'

export const moduleId = "user";
export const state = {
  //登录中
  loggingIn: false,
  //
  projectType: "",


  //是否在初始化中
  initializing: true,
  //是否在请求功能列表
  menuLoading: true,
  menuSuccess: false,

  userBaseInfo: null,
  menuList: [],
  roleCodes: [],


  goJssStatus: true,
  goJssToken: null,

  serviceType: null,
  firstLogin: false,

  // 用户id（修改密码使用）
  userId: null,

  //注册
  isVerify: false,
  agreementText: '请稍等...',
  isError: false,
  loginFlag: 1,//登陆方式 1 正常登录标识 2 强制退出其他用户标识
  initStatus: 1,
  nextCloseDate: '',
  hotKeyList: [],//快捷列表

  messageList: [],//这里面存放的都是已经发送成功的消息
  responseResult: {//接口返回值
    messageQuery: [],//信息列表
    updateQuery: [],//新增后查询回来的消息
    messageType: '',//用户操作类型
    allRecordQuery: [],
    pictureRecordQuery: [],
    fileRecordQuery: [],
    reSet: false,//是否重置聊天内容
  },
  corpUser: null,//公司用户
  records: {
    allRecord: [],
    pictureRecord: [],
    fileRecord: [],
  },
  business: {
    businessProduct: null,
    businessProductLoading: false,
  },
  uuid: null,
  imgBase64: null,
  isImgVerification: false,
  isValidUUID: false,
  departmentList: [], //部门列表
  personalList: [],//用户列表
  accountId: "",
  currOrgId: "",//其他系统跳转至本系统的单位ID
};

export const actions = {
  async login({ commit, dispatch, rootState }, { username, pwd }) {
    commit("onLoginStart");
    //移除不必要缓存
    AppPersistence.removeAll();
    //登录

    let loginRes = await UserApi.login(username, pwd, state.loginFlag);
    if (!loginRes || !loginRes.result) {
      //判断是否第一次登陆
      if (loginRes.code === '22222') {
        commit('setFirstLogin', true);
        commit('setUserId', loginRes.error.data);
      }
      //判断此账户是否已登录过
      if (loginRes.code === '33333') {
        setMessage({
          type: MSG_TYPES.WARNING,
          mode: MSG_MODES.MESSAGE_BOX,
          message: "该用户已经登陆，是否强制退出？",
          title: "提示",
          onOk: () => {
            commit('setLoginFlag', 2);//强制登陆
            dispatch('login', { username, pwd });
          },
          showCancelButton: true,
        })
      }
      UserPersistence.clear();
      commit("onLoginEnd");
      return;
    };
    commit('setLoginFlag', 1);//正常登录
    //存储token
    let userToken = loginRes.accessToken;
    UserPersistence.saveToken(userToken);
    let baseInfo = {
      user: {
        ...loginRes.value,
        name: loginRes.value.uname,
        code: loginRes.value.ucode
      }
    };
    UserPersistence.saveBaseInfo(baseInfo);
    commit("setUserBaseInfo", baseInfo);
    if (UserPersistence.getBaseInfo().user.roles.length > 0) {
      dispatch("getMenus", { roleId: UserPersistence.getBaseInfo().user.roles[0].id });  // 后期会用   获取菜单
    } else {
      setMessage({
        type: MSG_TYPES.WARNING,
        message: '用户无权限，请先联系管理员分配权限！'
      });
      router.push({
        name: 'login',
      });
    }

    setMessage({
      type: MSG_TYPES.SUCCESS,
      message: "登录成功!正在跳转..."
    });

    router.push({ name: 'admin' });

    setTimeout(() => {
      commit("onLoginEnd");
    }, 1000)
  },

  async getMenus({ state, commit, dispatch }, { flag, roleId }) {
    let serviceType = UserPersistence.getServiceType();
    let user = UserPersistence.getBaseInfo().user;
    let query = {
      rootServiceId: serviceType,
      userId: user.id,
      orgId: UserPersistence.getOrgId(),
    };

    let res = await UserApi.getMenus(query);
    if (res.result) {
      if (res.value === undefined || res.value.length < 1) {
        setMessage({
          type: MSG_TYPES.WARNING,
          message: '用户无权限，请先联系管理员分配权限!'
        });
        commit("onMenuEnd");
        commit("setInitStatus", 3);
        return;
      }
      let baseInfo = UserPersistence.getBaseInfo();
      baseInfo = {
        ...baseInfo,
        menuList: res.value,
      };
      UserPersistence.saveBaseInfo(baseInfo);
      commit("setUserBaseInfo", baseInfo);
      commit("updateMenuList", res.value);
      //更新菜单title
      setRouterTitle(menuRouters, res.value);
    }
  },

  async init({ state, commit, dispatch }){
    let res = await UserApi.init(UserPersistence.getOrgId());
    if(res.result){
      UserPersistence.saveaccountingStandards(res.value.currOrg.accountingStandards);
      UserPersistence.saveOrgId(res.value.currOrgId);
    }
  },

  async orgInitRules({ commit }, { orgId, accountingStandardsId }) {
    let res = await UserApi.orgInitRules({
      orgId: orgId,
      accountingStandardsId: accountingStandardsId,
      moduleType: '2'
    });
  },

  async loadBaseInfo({ commit, dispatch, rootState }, data) {




    //获取账号信息
    commit("onInitStart");
    var timer = setTimeout(() => {
      commit("setInitStatus", 2);

    }, 1000);
    // let accountRes = await UserApi.init(orgId);
    // if (!accountRes || !accountRes.result) {
    //   commit("setInitStatus",3);
    //   return
    // };
    // let baseInfo = _.cloneDeep(UserPersistence.getBaseInfo());
    // commit("account-info/setShowEcharts",1,{root:true})
    // baseInfo = {
    //   ...baseInfo,
    //   currOrgId: accountRes.value.currOrgId,
    //   currOrg: accountRes.value.currOrg,
    // };

    // UserPersistence.saveBaseInfo(baseInfo);


    // dispatch('orgInitRules', {orgId: orgId, accountingStandardsId: baseInfo.currOrg.accountingStandards});
    //dispatch("getDepartmentQuery", accountRes.value.currOrgId);

    let baseInfo = _.cloneDeep(UserPersistence.getBaseInfo())
    baseInfo = {
      ...baseInfo,
      currOrg: { ...data }
    }
    UserPersistence.saveBaseInfo(baseInfo);
    commit("setUserBaseInfo", baseInfo);

  },
  //修改服务类型
  changeServiceType({ state, commit, dispatch }, serviceType) {
    //存储服务类型
    UserPersistence.saveServiceType(serviceType);
    commit('setServiceType', serviceType);
  },

  async changePwd({ state, dispatch }, query) {
    let res = await UserApi.changePwd(query);
    if (res.result) {
      dispatch('login', { username: query.ucode, pwd: query.password })
    }
  },

  //搜索账套列表
  async getAccountingList({ commit, state }, params) {
    let res = await OrgApi.accountInit({});
    if (res.result) {
      console.log("setCurrOrgId=====",)
      commit("initAccountSelect", res.value.orgList);
    }
  },

  // 获取uuid
  async getUUID({ commit, dispatch }) {
    let res = await UserApi.getUUID();
    if (res.result) {
      commit('setUUID', res.value.uuid);
      dispatch('getVerificationImg');
    }
  },

  // 根据uuid获取图片验证码
  async getVerificationImg({ state, commit }) {
    let res = await UserApi.getVerification({ uuid: state.uuid });
    if (res.result) {
      commit('setImgBase64', res.value.img);
    }
  },

  // 验证图片验证码
  async checkVerification({ commit }, imgCode) {
    let res = await UserApi.checkVerification({
      uuid: state.uuid,
      value: imgCode
    });
    if (res.result) {
      commit('setIsImgVerification', res.value)
    }
  },

  //获取手机验证码
  async getMobileCode({ commit, state }, { mobile, value }) {
    let res = await UserApi.getMobileCode({
      "mobile": mobile,
      "uuid": state.uuid,
      "value": value
    });
    if (res.result) {
      commit('setIsValidUUID', true);
    } else {
      commit('setIsError', true);
    }
  },

  //手机验证码验证
  async identifyingCode({ commit, state }, query) {
    let res = await UserApi.identifyingCode(query);
    if (res.result) {
      setMessage({
        type: MSG_TYPES.SUCCESS,
        message: '验证成功!'
      });
      commit('setIsVerify', true);
    }
  },
  //找回密码
  async findPwd({ state, dispatch }, query) {
    let res = await UserApi.findPwd(query);
    if (res.result) {
      setMessage({
        type: MSG_TYPES.SUCCESS,
        message: '密码已设置为新密码!'
      });
      router.push({
        name: 'index',
      });
      dispatch('index', { username: query.ucode, pwd: query.password })
    }
  },

  async signUp({ state, commit, dispatch }, query) {
    // let tempWindow = window.open('about:blank', '_blank');
    let res = await UserApi.signUp(query);
    if (res.result) {
      setMessage({
        type: MSG_TYPES.SUCCESS,
        message: '注册成功!'
      });
      window.location = res.value;
    }
    commit('setIsVerify', false);
  },

  //查询系统环境以及用户是否有新增账套权限
  async getRte({ commit, state }) {
    let res = await UserApi.getRte();
    if (res.result) {
      UserPersistence.saveRte(res.value || {});
    }
  },

  /**
   * 查询部门
   * @param post
   * @param list: {"isContentEmpty": true,"notNeedPage": true,isInactive:false}
   * "isContentEmpty": false,  //是否包含预置的空数据，在查询账表、凭证中使用时应设置为true
   * "notNeedPage": true,  //true不需要分页，如需分页则可以不传或给false
   * isInactive: null, //是否停用: true 停用, false 可用
   * @returns {*}
   */
  // async getDepartmentQuery({ commit, state}, orgId){
  //   const list = {
  //     orgId: orgId || UserPersistence.getBaseInfo().currOrgId,
  //     "isContentEmpty": false,
  //     "notNeedPage": true,
  //     isInactive:false
  //   };
  //   let res = await UserApi.departmentQuery(list);
  //   if(res.result){
  //     commit("setDepartmentList", res.value);
  //   }
  // },
  async asyncAssignment({ commit, state, dispatch }, data) {      //进入帐套，或者切换帐套时调用此接口，用于初始化同步单据流水，个性化设置，资产用途 增减方式
    const params = {
      orgId: UserPersistence.getBaseInfo().currOrgId,
      ...data
    }
    let res = await UserApi.asyncAssignment(params);
  },
  //获取人员列表
  async getPersonalList({ commit, state }) {
    const params = {
      notNeedPage: false,
      pageObject: { currentPage: 1, pageSize: 50 }
    };
    let res = await UserApi.queryPersonalList(params);
    if (res.result) {
      commit("setPersonalList", res.value.dataList);
    };

  },

};

export const mutations = {
  initAccountSelect(state, value) {
    let baseInfo = UserPersistence.getBaseInfo();
    baseInfo = {
      ...baseInfo,
      orgList: value,
      orgId: baseInfo.currOrgId || value[0].id
    };
    UserPersistence.saveBaseInfo(baseInfo);
    state.userBaseInfo = baseInfo;
  },
  setOrgId(state, value){
    state.userBaseInfo.orgId = value;
  },
  setAccountId(state, data) {
    state.accountId = data
  },
  setProjectType(state, data) {
    state.projectType = data

  },
  onLoginStart(state) {
    state.loggingIn = true;
  },
  onLoginEnd(state) {
    state.loggingIn = false;
  },
  //基础信息请求状态
  onInitStart(state) {
    state.initializing = false;
  },
  onInitEnd(state) {
    state.initializing = true;
  },
  //功能列表请求状态
  onMenuStart(state) {
    state.menuLoading = false;
  },
  onMenuEnd(state) {
    state.menuLoading = true;
  },
  setMenuSuccess(state, visible) {
    state.menuSuccess = visible;
  },
  setUserBaseInfo(state, userBaseInfo) {
    state.userBaseInfo = userBaseInfo;
  },
  updateMenuList(state, menuList) {
    state.menuList = menuList;
  },
  setFirstLogin(state, visible) {
    state.firstLogin = visible;
  },
  setUserId(state, id) {
    state.userId = id;
  },
  setLoginFlag(state, flag) {
    state.loginFlag = flag;
  },

  setServiceType(state, type) {
    state.serviceType = type;
  },

  logout(state) {
    //TODO: 清空用户信息

    UserPersistence.clear();
  },

  //注册
  setIsVerify(state, visible) {
    state.isVerify = visible
  },
  setUUID(state, uuid) {
    state.uuid = uuid;
  },
  setImgBase64(state, base64) {
    state.imgBase64 = base64;
  },
  setIsImgVerification(state, flag) {
    state.isImgVerification = flag;
  },
  setIsValidUUID(state, flag) {
    state.isValidUUID = flag;
  },
  //验证出错
  setIsError(state, visible) {
    state.isError = visible;
  },
  setInitStatus(state, status) {
    state.initStatus = status;
  },
  setHotKeyList(state, list) {
    if (!list) list = [];
    state.hotKeyList = list;
    if (state.menuList.length === 0 && UserPersistence.getBaseInfo().menuList && UserPersistence.getBaseInfo().menuList.length !== 0) {
      state.menuList = UserPersistence.getBaseInfo().menuList;
    }
    let l = state.menuList.length;
    let k = list.length;
    if (l > 0) {
      for (let i = 0; i < l; i++) {
        if (k === 0) {
          state.menuList[i].hotKeyCode = '';
          state.menuList[i].hotKey = '';
        } else {
          for (let j = 0; j < k; j++) {
            if (list[j].functionId === state.menuList[i].id) {
              state.menuList[i].hotKeyCode = list[j].code;
              state.menuList[i].hotKey = list[j].value;
              break;
            } else {
              state.menuList[i].hotKeyCode = '';
              state.menuList[i].hotKey = '';
              break;
            }
          }
        }

      }
    }

  },

  updateHotList(state, { newHotKey, oldKeyCode }) {
    if (newHotKey) {
      let ind = ArrayUtils.getItemIndex(state.hotKeyList, 'code', oldKeyCode);
      if (ind > -1) {
        state.hotKeyList.splice(ind, 1, newHotKey)
      } else {
        state.hotKeyList.push(newHotKey)
      }
    } else if (oldKeyCode) {
      let ind = ArrayUtils.getItemIndex(state.hotKeyList, 'code', oldKeyCode);
      if (ind > -1) {
        state.hotKeyList.splice(ind, 1)
      }
    }
  },
  setResponseResult(state, { type, data }) {//设置接口返回值
    state.responseResult[type] = data;
  },
  setCorpUser(state, data) {
    state.corpUser = data
  },
  //设置部门列表
  setDepartmentList(state, data) {
    state.departmentList = data;
  },
  setPersonalList(state, data) {
    state.personalList = data;
  },
  setCurrOrgId(state, id) {
    state.currOrgId = id;
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/user/index.js